import { useCallback, useEffect, useState } from 'react';
import { getYoutubeQuotaStats, type YoutubeQuotaStats } from '../api/admin';

export function useYoutubeQuota() {
  const [stats, setStats] = useState<YoutubeQuotaStats | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getYoutubeQuotaStats();
      setStats(res.data.data);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh().catch(() => setStats(null));
  }, [refresh]);

  return { stats, loading, refresh };
}
